// extracted by mini-css-extract-plugin
module.exports = {"root":"CardWrapper__root--f13IZ","bounce":"CardWrapper__bounce--3LBVF"};